import { Component, Input, OnInit } from '@angular/core';
export enum statusProject {
  VALIDATED = 'VALIDATED',
  IN_PROGRESS = 'IN_PROGRESS',
  WAITING = 'WAITING',
  CANCELED = 'CANCELED',
}
@Component({
    selector: 'pr-project-progress-badge',
    templateUrl: './pr-project-progress-badge.component.html',
    styleUrls: ['./pr-project-progress-badge.component.scss'],
    standalone: false
})
export class PrProjectProgressBadgeComponent implements OnInit {
  @Input() status: statusProject;
  icon: string;
  clazz: string;
  content: string;
  ngOnInit() {
    switch (this.status) {
      case statusProject.VALIDATED:
        this.clazz = 'valid-project';
        this.icon = 'sp-validate';
        this.content = 'Validé';
        break;

      case statusProject.IN_PROGRESS:
        this.clazz = 'progress-project';
        this.icon = 'sp-in-progress';
        this.content = 'En cours';
        break;

      case statusProject.WAITING:
        this.clazz = 'waiting-project';
        this.icon = 'sp-waiting';
        this.content = 'En attente';
        break;

      case statusProject.CANCELED:
        this.clazz = 'canceled-project';
        this.icon = 'fa-ban';
        this.content = 'Annulé';
        break;

      default:
        this.clazz = 'grey';
        break;
    }
  }
}
